import { Component, Input, ViewChild } from '@angular/core';
import { NavController, ViewController } from 'ionic-angular';


import { Account } from '../../../model/account';
import { Subscription } from 'rxjs';
import { UserManager } from '../../../services/managers/user.manager';

import { Organization } from '../../../model/organization';
import { NavParams } from 'ionic-angular';
import { AccountHelper } from '../../../lib/accountHelper';
import { OrganizationListPage } from './organization-list';
import { NominationService } from '../../../services/nomination.service';
import { HorseNomination } from '../../../model/horseNomination';
import { StaffAccessSection } from './staff-access/staff-access';

@Component({
    selector: 'manage-organization',
    templateUrl: 'organization.html'
})
export class OrganizationPage {
    @ViewChild('organizationList') organizationList: OrganizationListPage;
    @ViewChild('staffAccess') staffAccess: StaffAccessSection;
    @Input('organization') organization: Organization;

    viewMode = 'nominations';
    viewSubMode = 'overview';
    
    accountHelper = AccountHelper.instance();
    account: Account = new Account();

    loadingData: boolean = true;
    popoverActive: boolean;

    condensed: boolean;
    prompted: boolean;
    subscriptions: Subscription[] = [];    

    constructor(public nav: NavController, private nominationService: NominationService, private userManager : UserManager, private viewCtrl: ViewController) { }

    load() {
        this.showSearch();

        this.subscriptions.push(this.userManager.account.subscribe(account => {
            this.account = account as Account;
        }));

        this.loadingData = false;
    }

    unload() {
        for(let i = 0; i < this.subscriptions.length; i++) {
            let subscription = this.subscriptions[i];

            if (!subscription.closed)
                subscription.unsubscribe();
        }
    }

    organizationSelected(organization: Organization) {
        this.organization = organization;

        setTimeout(() => {
            if (!this.organization.id) {
                this.showSettings();     
            } else {
                this.showStaff();
            }
        }, 0);
    }

    showSearch() {
        this.viewMode = 'search';
        this.organizationList.load();
    }

    showNominations() {
        this.viewMode = 'nominations';
        this.viewSubMode = 'overview';
    }

    showCustomers() {
        this.viewMode = 'customers';
    }

    showStallions() {
        this.viewMode = 'stallions';
    }

    showStaff() {
        this.viewMode = 'staff';
        this.staffAccess.load();
    }

    showReports() {
        this.viewMode = 'reports';
        this.viewSubMode = 'nominatedOffspring';
    }

    showSettings() {
        this.viewMode = 'settings';
    }

    showRequests() {
        this.viewMode = 'requests';
    }

    showTransactions() {
        this.viewMode = 'transactions';
    }
    
    showPayments() {
        const link = document.createElement('a');
        const token = encodeURIComponent(JSON.stringify(this.accountHelper.token));
        link.href = 'https://nextgendemo.z19.web.core.windows.net/payments/dashboard?organizationId=' + this.organization.id + '&token=' + token;
        link.target = '_blank';

        link.click();
    }

    back() {
        this.nav.pop();
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/organization/organization.ts